import { Tabs } from '@mantine/core';
import { useShallow } from 'zustand/shallow';

import { Catalogue } from 'app/modules/wallforming/components/catalogue-container/Catalogue';
import { CatalogueArticlePreview } from 'app/modules/wallforming/components/catalogue-container/CatalogueArticlePreview';
import { useGetArticleData } from 'app/modules/wallforming/components/catalogue-container/hooks/useGetArticleData';
import { PlacementSolutionList } from 'app/modules/wallforming/components/setting-container/automated-placement/PlacementSolutionList';
import { PlacementSolutionPreview } from 'app/modules/wallforming/components/setting-container/automated-placement/PlacementSolutionPreview';
import { PlacementTab } from 'app/modules/wallforming/components/setting-container/types/placementTab';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface CornerPlacementContainerProps {
    areCornerSolutionsLoading: boolean;
}

export const CornerPlacementContainer = ({ areCornerSolutionsLoading }: CornerPlacementContainerProps) => {
    const { selectedSettingType, automatedPlacementTab, setAutomatedPlacementTab } = usePlacementStore(
        useShallow((state) => ({
            selectedSettingType: state.selectedSettingType,
            automatedPlacementTab: state.automatedPlacementTab,
            setAutomatedPlacementTab: state.setAutomatedPlacementTab
        }))
    );

    useGetArticleData({
        settingType: selectedSettingType,
        enabled: automatedPlacementTab === PlacementTab.CATALOGUE
    });

    return (
        <Tabs
            className="automated-placement-tabs flex min-h-0 h-full min-w-0 flex-1 flex-col overflow-hidden [&_.tabs]:mb-2!"
            classNames={{ list: 'shrink-0', tab: 'automated-placement-tab' }}
            defaultValue={PlacementTab.SOLUTIONS}
            keepMounted={false}
            value={automatedPlacementTab}
            onChange={(value) => value && setAutomatedPlacementTab(value as PlacementTab)}
        >
            <Tabs.List>
                <Tabs.Tab value={PlacementTab.SOLUTIONS}>Solutions</Tabs.Tab>
                <Tabs.Tab value={PlacementTab.CATALOGUE}>Catalogue</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel className="min-h-0 flex-1 overflow-hidden" keepMounted={false} value={PlacementTab.CATALOGUE}>
                <div className="grid h-full min-h-0 min-w-0 grid-rows-[minmax(9rem,1.1fr)_minmax(8rem,0.9fr)] gap-2 overflow-hidden">
                    <div className="min-h-0 min-w-0 overflow-hidden" data-automated-catalogue>
                        <Catalogue settingType={selectedSettingType} showFilter={false} />
                    </div>
                    <div className="min-h-0 min-w-0 overflow-hidden">
                        <CatalogueArticlePreview />
                    </div>
                </div>
            </Tabs.Panel>
            <Tabs.Panel className="min-h-0 flex-1 overflow-hidden" keepMounted={false} value={PlacementTab.SOLUTIONS}>
                <div className="grid h-full min-h-0 min-w-0 grid-rows-[minmax(10rem,1fr)_minmax(11rem,0.95fr)] gap-2 overflow-hidden">
                    <div className="min-h-0 overflow-hidden">
                        <PlacementSolutionList
                            isLoading={areCornerSolutionsLoading}
                        />
                    </div>
                    <div className="min-h-0 min-w-0 overflow-hidden">
                        <PlacementSolutionPreview />
                    </div>
                </div>
            </Tabs.Panel>
        </Tabs>
    );
};
